import React, { memo } from 'react'
import styles from './RightSideDialog.module.scss'

type Props = {
    title: string
    children: React.ReactNode
    onCloseDialog: () => void
}

const RightSideDialog: React.FC<Props> = memo((props: Props) => {
    const { title } = props

    function handleChildClick(event : React.MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
    }

    return (
        <div className={styles.container} onClick={props.onCloseDialog}>
            <div className={styles.dialogContainer} onClick={handleChildClick}>
                <div className={styles.dialogHeader}>
                    {title}
                    <svg className={styles.clickable} onClick={props.onCloseDialog} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9.35355 8.64645C9.15829 8.45118 8.84171 8.45118 8.64645 8.64645C8.45118 8.84171 8.45118 9.15829 8.64645 9.35355L11.2929 12L8.64645 14.6464C8.45118 14.8417 8.45118 15.1583 8.64645 15.3536C8.84171 15.5488 9.15829 15.5488 9.35355 15.3536L12 12.7071L14.6464 15.3536C14.8417 15.5488 15.1583 15.5488 15.3536 15.3536C15.5488 15.1583 15.5488 14.8417 15.3536 14.6464L12.7071 12L15.3536 9.35355C15.5488 9.15829 15.5488 8.84171 15.3536 8.64645C15.1583 8.45118 14.8417 8.45118 14.6464 8.64645L12 11.2929L9.35355 8.64645Z" fill="black"/>
                    </svg>
                </div>
                <div>
                    {props.children}
                </div>
            </div>
        </div>
    )
})

export default RightSideDialog